import { createAction, createReducer } from "@reduxjs/toolkit";
import { get, isFunction } from "lodash-es";

const Actions = {
  setPageLoading: "setPageLoading",
  setButtonLoading: "setButtonLoading",
  setLoader: "setLoader",
};

//actions
export const setLoader = createAction(Actions.setLoader);

export const getLoadingData = (state, screen, actionName) => {
  if (actionName) {
    let actionNameString;
    if (typeof actionName === "string") actionNameString = actionName;
    else if (isFunction(actionName.toString())) actionNameString = actionName.toString();
    
    if (actionNameString) {
      return get(state, `loader.loadingObj.${actionNameString}`, {});
    }
  } else {
    const currentScreen = get(state, "loader.loadingObj.screen", "");
    if (currentScreen === screen) {
      return state.loader.loadingObj;
    }
    return {};
  }
};

export const getPageLoading = (state, screen) => {
  const currentScreen = get(state, "loader.loadingObj.screen", "");
  if (currentScreen === screen) {
    return state.loader.loadingObj.isPageLoading;
  }
  return false;
};

export const getButtonLoading = (state, screen) => {
  const currentScreen = get(state, "loader.loadingObj.screen", "");
  if (currentScreen === screen) {
    return state.loader.loadingObj.isButtonLoading;
  }
  return false;
};

// initial state
const initialState = {
  loadingObj: {
    screen: "",
    isPageLoading: false,
    isButtonLoading: false,
  },
};

//reducer
export default createReducer(initialState, (builder) => {
  builder.addCase(setLoader, (state, action) => {
    const { actionName, ...restPayload } = action.payload;

    if (actionName) {
      state.loadingObj = {
        ...state.loadingObj,
        [actionName]: {
          ...state.loadingObj[actionName],
          ...restPayload
        }
      }
    } else {
      state.loadingObj = {
        ...state.loadingObj,
        ...action.payload
      };
    }
  });
});

